import Image from "next/image";
import Head from "next/head";
import styles from "./two-year-upsc-program.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Sadhana_Form from "./two-year-upsc-program-form";
import Interest from "../../components/might-be-interest";
import NewiconA from "../../assets/images/header/pdf-download1.png";
import sadhanaimg from "../../assets/images/upsc/sadhana/Sadhana-webbanner.jpg";
import sadhanahead from "../../assets/images/upsc/sadhana/sadhana-header.jpg"
import Link from "next/link";

const Two_Year_Classroom_Programme = () => {

     const feestructure3 =[
          {center: "Chennai",batch: "Batch 6 - Regular ", start: " 15th Dec 2025",timing: "05-30 pm to 08-00 pm",
                cont3:(<Link href="https://www.shankariasacademy.com/pdf/upsc_sadhana/Sadhana-Brochure-Evening-B6-2025.pdf" target="_blank" className={`${styles.paybill}`}> 
                Click here</Link>),
                pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            },

        {center: "Chennai",batch: "Batch 5 - Weekend ", start: " 14th Dec 2025",timing: "02-00 pm to 07-30 pm",
                cont3:(<Link href="https://www.shankariasacademy.com/pdf/upsc_sadhana/Sadhana-Brochure-Weekend-B5-2025-DEC.pdf" target="_blank" className={`${styles.paybill}`}> 
               Click here</Link>),
                pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            },


        {center: "Chennai",batch: "Batch 4 - Weekend ", start: " 23rd Nov 2025",timing: "02-00 pm to 07-30 pm",
                cont3:(<Link href="https://www.shankariasacademy.com/pdf/upsc_sadhana/Sadhana-Brochure-Weekend-B4-2025-NOV.pdf" target="_blank" className={`${styles.paybill}`}> 
                Click here</Link>),
                pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            },


        {center: "Chennai",batch: "Batch 3 - Regular", start: "23rd Oct 2025",timing: "05-30 pm to 08-00 pm",
          cont3:(<Link href="https://www.shankariasacademy.com/pdf/upsc_sadhana/Sadhana-Brochure-Regular-B3-2026.pdf" target="_blank"  className={`${styles.paybill}`}> 
               Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            },

            {center: "Chennai",batch: "Batch 2 - Regular", start: " 4th Sep 2025",timing: "05-30 pm to 08-00 pm",
          cont3:(<Link href="https://www.shankariasacademy.com/pdf/upsc_sadhana/Sadhana-Brochure-B2-Sep-2025-26.pdf" target="_blank" className={`${styles.paybill}`}> 
                Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            },

        

            {center: "Chennai",batch: "Batch 1 - Weekend", start: " 9th Aug 2025",timing: "02-00 pm to 07-30 pm",
            cont3:(<Link href="https://www.shankariasacademy.com/pdf/upsc_sadhana/Sadhana-Brochure-Weekend-B1-2026.pdf" target="_blank" className={`${styles.paybill}`}> 
                    Click here</Link>),
                pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                        <button className={`${styles.normalbutton1} btn btn-danger`}>
                        Pay Now
                        </button>
                    </a>)
                },

        

        {center: "Bengaluru ",batch: "Batch 1 - Weekend", start: " 16th Nov 2025",timing: "08-30 am to 01-30 pm",
          cont3:(<Link href="https://www.shankariasacademy.com/pdf/upsc_sadhana/Sadhana-Brochure-Weekend-B4-2025-NOV.pdf" target="_blank"  className={`${styles.paybill}`}> 
               Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}>
                      Pay Now
                    </button>
                </a>)
            },
            
    ];
    

    return (
        <>
        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Two Year Classroom Programme - Shankar IAS Academy</title>
            <meta name="title" content="Two Year Classroom Programme - Shankar IAS Academy" />
            <meta name="description" content="" />
            <link rel="canonical" href="https://www.shankariasacademy.com/two-year-upsc-program/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Two Year Classroom Programme - Shankar IAS Academy" />
            <meta property="og:description" content="" />
            <meta property="og:url" content="https://www.shankariasacademy.com/two-year-upsc-program/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
            <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
        </Head>

        <Navbar title="upsc" />
        <div className="container">
            <div className="row">
                <div className="col pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>Two Year Classroom Programme</h1>
                </div>
            </div>
            <div className="row">
                <div className="col pt-2 mb-3">
                    <Image src={sadhanaimg} alt="Sadhana UPSC CSE 2025 two year classroom programme banner" title="Sadhana UPSC CSE 2027 two year classroom programme" className="img-fluid w-100"/>
                </div>
            </div>
        </div>

        {/* form 
        <Sadhana_Form/> */}
        <div className="container">
            <h2 className={`${styles.acheiverrank} text-center mb-0 fs-5`}> Sadhana UPSC CSE 2027 two year classroom programme (GSPCM)</h2>
            <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
            <div class="col-12  col-md-6 offset-md-3 mt-4 mb-2">
            <div class={`${styles.addmissionform} npf_wgts `} data-height="600px"   data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
        </div>
        </div>
      

        {/* table */}
        <section  id="courseandfees">
        <div className="container pt-xl-4" >
            <Image src={sadhanahead} alt="Sadhana table head" title="Sadhana UPSC CSE 2027 two year classroom programme" className="img-fluid h-100"/>
        <div className="row">
            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Center</div>
            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Batch</div>
            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Starts on</div>
            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Timing</div>
            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Schedule</div> 
            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Admission</div>
            <hr/>
        </div>
                        
        {feestructure3.map((item,index)=>(
            <div className={`${styles.facultyborder3} row`}>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.center}</div>

                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.batch}</div>
            
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.start}</div>

                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3  pb-md-3`}>{item.timing}</div>

                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-2`}>{item.cont3}</div> 

                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Admission</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-2`}>
            {item.pay}
            </div>
            <hr/>
            </div>
        ))} 
        </div>
        </section>

        <Interest />
        <Footer />                      
        </>
    )
}
export default Two_Year_Classroom_Programme
